<template>
  <div class="artist-info__commission-data">
    <div class='artist-info-part__title'>佣金收入</div>
    <el-form ref='searchForm' size='mini' :inline='true'>
      <el-form-item label='月份选择：'>
        <span slot='label'><b>月份：</b></span>
        <el-date-picker
          v-model='range_month'
          type='monthrange'
          align='right'
          unlink-panels
          range-separator='至'
          start-placeholder='开始月份'
          end-placeholder='结束月份'
          format='yyyy-MM'
          value-format='yyyy-MM'
          :clearable="false"
          :picker-options='pickerOptions' @change='getData'>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type='primary' @click='getData()'>查询</el-button>
      </el-form-item>
    </el-form>
    <div class="commission-platforms">
      <div class='platform-row' v-for="(row,index) in plots" :key="index">
        <div class='platform-item' v-for="(item) in row" :key="item.platform_code">
          <el-button v-if="item.platform_code!=='all'" type='text' @click="showDetail(item)">查看详情</el-button>
          <div class="platform-item_left">
            <div class='num'>￥{{ item.total|numberFormatW }}</div>
            <div class='platform-name'>
              <img v-if="item.platform_logo" :src="item.platform_logo" alt="">
              {{ item.platform_name }}
            </div>
          </div>
          <div class="platform-item_img">
            <img src="@/assets/images/fork.png" alt="">
          </div>
          <div class="platform-item_right">
            <div><span>短视频佣金</span>{{ item.income_3|numberFormatW }}</div>
            <div><span>直播佣金</span>{{ item.income_4|numberFormatW }}</div>
            <div><span>直播坑位费</span>{{ item.income_5|numberFormatW }}</div>
          </div>
        </div>
      </div>
    </div>
    <el-divider />
    <commission-bar-chart :artist-id='artistId' />
    <el-dialog
      :title="detail.platform_name+'佣金详情' || '佣金详情'"
      :visible.sync="detail.show"
      width="600px">
      <el-table :data="detail.data" border size="mini" show-summary>
        <el-table-column property='time_month' label='月份' />
        <el-table-column property="income_3" label="短视频佣金" sortable>
          <template v-slot="{row:{income_3}}">
            <span class='money'>{{ income_3|numberFormatW }}</span>
          </template>
        </el-table-column>
        <el-table-column property="income_4" label="直播佣金" sortable>
          <template v-slot="{row:{income_4}}">
            <span class='money'>{{ income_4|numberFormatW }}</span>
          </template>
        </el-table-column>
        <el-table-column property="income_5" label="直播坑位费" sortable>
          <template v-slot="{row:{income_5}}">
            <span class='money'>{{ income_5|numberFormatW }}</span>
          </template>
        </el-table-column>
        <el-table-column label="合计">
          <template v-slot="{row:{income_3,income_4,income_5}}">
            <span class='money'>{{ (income_3 + income_4 + income_5)|numberFormatW }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import CommissionBarChart from '@/pages/dashboard/revenue/CommissionBarChart.vue'

const pickerOptions = {
  shortcuts: [{
    text: '本月',
    onClick(picker) {
      picker.$emit('pick', [new Date(), new Date()])
    }
  }, {
    text: '今年至今',
    onClick(picker) {
      const end = new Date()
      const start = new Date(new Date().getFullYear(), 0)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近六个月',
    onClick(picker) {
      const end = new Date()
      const start = new Date()
      start.setMonth(start.getMonth() - 5)
      picker.$emit('pick', [start, end])
    }
  }]
}
export default {
  name: 'CommissionData',
  components: { CommissionBarChart },
  computed: {
    ...mapGetters(['userPermissions'])
  },
  props: {
    artistId: {
      type: String,
      require: true
    }
  },
  watch: {
    artistId() {
      this.init()
    }
  },
  data() {
    return {
      loading: false,
      range_month: [moment().startOf('year').format('YYYY-MM'), moment().format('YYYY-MM')],// 月份区间
      plots: [],
      platforms: [],
      detail: {
        show: false,
        data: [],
        platform_code: '',
        platform_name: ''
      },
      pickerOptions
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getData()
    },
    async getData() {
      // 初始化合计数据
      const total = {
        platform_name: '合计',
        platform_code: 'all',
        income_3: 0,
        income_4: 0,
        income_5: 0,
        total: 0
      }

      // 初始化平台列表
      const platforms = []

      // 设置请求参数
      const params = {
        artist_id: this.artistId,
        // 设置请求的时间范围
        start_time: moment(this.range_month[0]).startOf('month').format('YYYY-MM-DD'),
        end_time: moment(this.range_month[1]).endOf('month').format('YYYY-MM-DD')
      }

      // 发送请求并获取数据
      const { list } = await this.$api.getRevenueItemStatistics(params)

      // 遍历获取的数据列表
      list.forEach(item => {
        // 如果当前项有数据
        if (item.has === 'Y') {
          // 累加收入数据到合计对象中
          total.income_3 += Number(item.income_3 || 0)
          total.income_4 += Number(item.income_4 || 0)
          total.income_5 += Number(item.income_5 || 0)
          total.total = Number(total.income_3) + Number(total.income_4) + Number(total.income_5)

          // 将当前项添加到平台列表中
          platforms.push({
            platform_logo: item.logo_url,
            platform_name: item.platform_name,
            platform_code: item.platform_code,
            income_3: Number(item.income_3 || 0),
            income_4: Number(item.income_4 || 0),
            income_5: Number(item.income_5 || 0),
            total: Number(item.income_3 || 0) + Number(item.income_4 || 0) + Number(item.income_5 || 0),
            items: item.items || []
          })
        }
      })

      // 将合计数据添加到平台列表的最前面
      platforms.unshift(total)

      // 更新组件的platforms数据
      this.platforms = platforms

      // 调用函数
      this.plotPlatforms()
    },

    plotPlatforms: function() {
      let plots = []
      const length = this.platforms.length
      if (length <= 4) {
        plots = [this.platforms]
      } else {
        const mid_length = parseInt((length / 2) + '')
        const tmp_1 = this.platforms.slice(0, mid_length)
        const tmp_2 = this.platforms.slice(mid_length)
        plots = [tmp_1, tmp_2]
      }
      this.plots = plots
    },
    showDetail: function(item) {
      this.detail = {
        show: true,
        data: item.items || [],
        platform_code: item.platform_code,
        platform_name: item.platform_name
      }
    }
  }
}
</script>

<style lang="scss">
.artist-info__commission-data {
  .platform-row {
    display: flex;
    flex: 1;

    .platform-item:hover {
      .el-button {
        opacity: 1;
      }
    }

    .platform-item {
      flex: 1; /* 这意味着每个项目将平均分配剩余空间 */
      padding: 20px; /* 添加一些内边距以便内容不会紧贴边缘 */
      background: #fff;
      box-shadow: 0 2px 10px 0 hsla(0, 0%, 92.2%, .5);
      border-radius: 6px;
      margin-bottom: 10px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      .el-button {
        position: absolute;
        right: 10px;
        top: 12px;
        opacity: 0;
      }

      &_left {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 50px;

        .num {
          color: #45474d;
          font-size: 16px;
          font-weight: 700;
          line-height: 16px;
          margin-bottom: 6px;
        }

        .platform-name {
          font-size: 14px;
          color: #8a8e99;

          img {
            width: 16px;
            height: 16px;
            margin-right: 5px;
            vertical-align: middle;
          }
        }
      }

      &_right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: 12px;
        height: 60px;
        color: #8a8e99;

        span {
          width: 68px;
          display: inline-block;
        }
      }

      &_img {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        margin: 0 10px;

        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
